import {Component, Input} from "@angular/core";
import {CommonModule} from '@angular/common';
import {FieldOkItemComponent} from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './plangruppe.list-view.html',
    styleUrls: ['./plangruppe.list-view.scss']
})
export class PlangruppeListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {}
}
